import script from "./BestlineVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./BestlineVideo.vue?vue&type=script&setup=true&lang=js"

import "./BestlineVideo.vue?vue&type=style&index=0&id=6f4e49b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f4e49b4"]])

export default __exports__